import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import Group from 'components/utils/Group'
import React from 'react'
import PromotionLabel from 'LuxKit/Label/PromotionLabel'

interface Props {
  benefit: App.LoyaltyBenefit;
  tier: App.LoyaltyTier;
  title: string;
  icon: React.ReactElement;
  promotion?: App.LabFeatureFlagResult;
}

function AccountDrawerBenefitHighlightItem(props: Props) {
  const { benefit, tier, title, icon, promotion } = props

  return (
    <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="center">
      <BodyTextBlock variant="small" startIcon={icon}>
        {title}
      </BodyTextBlock>
      <Group direction="horizontal" verticalAlign="center" gap={12}>
        {promotion?.enabled && <PromotionLabel variant="premium">New</PromotionLabel>}
        <LoyaltyTierLabel kind="secondary" tier={tier}>
          {benefit.unlimited && <>Unlimited</>}
          {!benefit.unlimited && <>
            {benefit.remaining === 0 && <>Redeemed</>}
            {benefit.remaining !== 0 && <>{benefit.remaining}x</>}
          </>}
        </LoyaltyTierLabel>
      </Group>
    </Group>
  )
}

export default AccountDrawerBenefitHighlightItem
